import L from "leaflet";
import { createElement } from "react";
import { renderToStaticMarkup } from "react-dom/server";
import { CATEGORIES } from "@/lib/categories";

const cache = {};

export const categoryIcon = (cat, active = false) => {
  const k = `${cat}-${active}`;
  if (cache[k]) return cache[k];
  const { color, Icon } = CATEGORIES[cat] || CATEGORIES.gobierno;
  const svg = renderToStaticMarkup(createElement(Icon, { size: 16, color: "#fff", strokeWidth: 2.4 }));
  cache[k] = L.divIcon({
    className: "hg-pin-wrap",
    html: `<div class="hg-pin${active ? " hg-pin-active" : ""}" style="--pin:${color}"><span>${svg}</span></div>`,
    iconSize: [36, 44],
    iconAnchor: [18, 42],
    popupAnchor: [0, -38],
  });
  return cache[k];
};

export const userIcon = (label) => cache[`user-${label}`] ||= L.divIcon({
  className: "hg-pin-wrap hg-user-wrap",
  html: `<div class="hg-user"><span class="hg-user-pulse"></span><span class="hg-user-dot"></span><span class="hg-user-label">${label}</span></div>`,
  iconSize: [22, 22],
  iconAnchor: [11, 11],
});
